import React from "react";
import FormLayout from '../FormLayout';
import FileField from './FileField';
import { Field } from 'redux-form';
import FileUpload from '../../components/FileUpload';
import { getFormImagePresetOverrides } from '../../services/image';

/** Class representing a form layout image field (client-side conversion + resize). */
class ImageField extends FileField {

    constructor(properties) {
        const defaults = ImageField.getDefaultOptions();
        const content = properties?.content && typeof properties.content === 'object'
            ? properties.content
            : {};

        super({
            ...defaults,
            ...properties,
            content: { ...defaults.content, ...content },
        });

        this.type = FormLayout.IMAGE;
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = super.getDefaultOptions();

        properties.extensions = ['jpeg'];
        properties.content = {
            max_width: 1920,
            max_height: 1920,
        };

        return properties;
    }

    /**
     * Return this field preview input
     */
    getInput(props) {
        return (
            <Field
                component={ FileUpload }
                type="file"
                name={this.reduxFieldName(props)}
                required={this.htmlRequired(props)}
                accept="image/*"
                optimizePreset="formImage"
                rejectOnProcessFailure
                presetOverrides={ getFormImagePresetOverrides(this) }
                className="form-control"
            />
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'image';
    }
}

export default ImageField;
